import { createSlice } from '@reduxjs/toolkit';

const actionJobsSlice = createSlice({
  name: 'actionJobs',
  initialState: {
    data: [],
    loading: true,
  },
  reducers: {
    hydrateActionJobs: (state, action) => {
      state.data = action.payload;
      state.loading = false;
    },

    requestActionJobs: (state, action) => {
      state.loading = true;
    },
  },
});

export default actionJobsSlice;
